<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">订单管理</el-breadcrumb-item>
            <el-breadcrumb-item>查验详情</el-breadcrumb-item>
        </el-breadcrumb>
        <el-container>
            <el-main style="overflow: auto;height: calc(100vh - 80px);">

              <h2>订单信息</h2>
              <el-form label-width="120px" label-position="left" style="margin-left: 20px;">
                <el-form-item label="订单号">
                  <label>{{refundInfo.orderNum}}</label>
                </el-form-item>
                <el-form-item label="联系人">
                  <label>{{refundInfo.linkman}}</label>
                </el-form-item>
                <el-form-item label="联系电话">
                  <label>{{refundInfo.linkPhone}}</label>
                </el-form-item>
                <el-form-item label="押金状态">
                  <label v-if="refundInfo.status == 1">待检验</label>
                  <label v-if="refundInfo.status == 2">待审核</label>
                  <label v-if="refundInfo.status == 3">退款中</label>
                  <label v-if="refundInfo.status == 4">已拒绝</label>
                  <label v-if="refundInfo.status == 5">已完成</label>
                </el-form-item>
                <el-form-item label="申请时间">
                  <label>{{refundInfo.createTime|timestampToTime}}</label>
                </el-form-item>
                <el-form-item label="押金总金额">
                  <label>￥{{refundInfo.totalCashPledge}}</label>
                </el-form-item>
                <el-form-item label="仓管员姓名">
                  <label>{{refundInfo.inspector}}</label>
                </el-form-item>
                <el-form-item label="检验时间">
                  <label>{{refundInfo.provingTime|timestampToTime}}</label>
                </el-form-item>
                <el-form-item label="查验结果" prop="bannerImage">
                  <el-upload
                    list-type="picture-card"
                    :action="this.host+'/fileUpload/ossBatch'"
                    :file-list="bnImages"
                    :limit="3">
                  </el-upload>
                </el-form-item>
                <el-form-item label="备注说明">
                  <label>{{refundInfo.remark}}</label>
                </el-form-item>
                <el-form-item label="可退金额">
                  <label>￥{{refundInfo.refCashPledge}}</label>
                </el-form-item>
                <el-form-item label="审核人姓名">
                  <label>{{refundInfo.verifier}}</label>
                </el-form-item>
                <el-form-item label="审核时间">
                  <label>{{refundInfo.auditTime|timestampToTime}}</label>
                </el-form-item>
              </el-form>


              <h2>商品明细</h2>
              <el-table :data="refundInfo.orderDetails" :header-cell-style="{background:'#eef1f6',color:'#606266'}"
                        border element-loading-text="拼命加载中" highlight-current-row
                        ref="userTable" size="small" style="width: 90%;margin-left: 20px;">
                <el-table-column label="商品名称" prop="commodityName">
                </el-table-column>
                <el-table-column label="数量" prop="amount">
                </el-table-column>
                <el-table-column label="单价" prop="sellingPrice">
                </el-table-column>
                <el-table-column label="押金" prop="cashPledge">
                </el-table-column>
                <el-table-column label="用餐日期" prop="mealDate" v-if="refundInfo.typeId == 3">
                  <template slot-scope="scope">
                    <div>{{scope.row.mealDate|timestampToTime}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="使用天数" prop="days" v-if="refundInfo.typeId == 2">
                </el-table-column>
              </el-table>


            </el-main>
        </el-container>
    </div>
</template>

<script>

    export default {
        name: "refundDetail",
        data() {
            return {
              refundInfo:{},
              bnImages:[],
            }
        },
        mounted() {
            if(this.$route.query.refundInfo){
              this.refundInfo = this.$route.query.refundInfo;
              let strings = this.refundInfo.image.split(",");
              for(let i=0;i<strings.length;i++){
                this.bnImages.push({url:strings[i]});
              }
              this.$forceUpdate();
            }
            console.log("this.refundInfo",this.refundInfo)
        },
        methods:{
            timestampToTime(timestamp) {
                let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                let Y = date.getFullYear() + '-'
                let M =
                    (date.getMonth() + 1 < 10 ?
                        '0' + (date.getMonth() + 1) :
                        date.getMonth() + 1) + '-'
                let D =
                    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
                let h =
                    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
                let m =
                    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                    ':'
                let s =
                    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
                return Y + M + D + h + m + s
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/convenience/refundDetail.vue